import { createElement, FC, useMemo } from "react";
import { Button, ButtonProps, SvgIconProps, Typography } from "@mui/material";
import { SvgIconComponent } from "@mui/icons-material";

interface TextIconButtonProps extends ButtonProps {
  text: string;
  icon: SvgIconComponent;
  iconLeft?: boolean;
  iconProps?: SvgIconProps;
}

const TextIconButton: FC<TextIconButtonProps> = ({
  text,
  icon,
  iconProps,
  iconLeft = false,
  ...buttonProps
}) => {
  const iconComponent = useMemo(() => {
    return createElement(icon, { ...iconProps, fontSize: "small" });
  }, [icon, iconProps]);

  return (
    <Button
      {...buttonProps}
      sx={{
        display: "flex",
        gap: "6px",
        flexDirection: iconLeft ? "row-reverse" : "row",
        alignItems: "center",
      }}
    >
      <Typography>{text}</Typography>
      {iconComponent}
    </Button>
  );
};

export default TextIconButton;
